import { virtualDir } from "./skyward.base.global";

const skyward = window.skyward;
export function buildAboutPopup()
{
    const options = { width: "15%", transparentGlass: true, draggable: true };

    const aboutPopup = $.ajax(
        {
            url: `${virtualDir}SkySys/About/GetAboutPopup?renderType=contentOnly`
        });
    skyward.modalLayer.showDialog("About", aboutPopup, ["close"], options);
}